import Heading from 'src/elements/typography/heading';
import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const BannerContainer = styled.div`
  max-width: 100vw !important;
  background: ${palette.engagementDropBackground};
  position: relative;
  display: grid;
  max-height: 1150px;
`

export const BannerContent = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  display: grid;
  justify-content: left;
  z-index: 2;
  grid-row: 1 / 2;
  grid-column: 1 / 2;
  box-sizing: border-box;
  padding-top: 81px;
`

export const ContentText = styled.div`
  justify-self: left;
  align-self: center;
  box-sizing: border-box;
  padding: 50px 70px 90px;

  @media screen and (max-width: ${layout.xlg}) {
    padding: 40px 70px 70px;
  }

  @media screen and (max-width: ${layout.lg}) {
    padding: 30px 70px 60px;
  }

  @media screen and (max-width: ${layout.subLg}) {
    padding: 15px 50px 40px;
  }

  @media screen and (max-width: ${layout.sm}) {
    padding: 15px 30px 40px;
  }

  @media screen and (max-width: ${layout.xs}) {
    padding: 100px 16px 190px;
  }
`

export const BannerHeadTitle = styled(Heading)`
  @media screen and (max-width: ${layout.xlg}) {
    line-height: 8.4rem;
  }

  @media screen and (max-width: ${layout.lg}) {
    line-height: 7.2rem;
  }

  @media screen and (max-width: ${layout.subLg}) {
    max-width: 630px;
    margin-right: auto;
    line-height: 4.5rem;
  }

  @media screen and (max-width: ${layout.sm}) {
    line-height: 4rem;
    max-width: 550px;
  }

  @media screen and (max-width: ${layout.xs}) {
    line-height: 3.1rem;
    max-width: 420px;
  }

  @media screen and (max-width: 370px) {
    font-size: 2.5rem;
    line-height: 2.5rem;
  }
`

export const BackgroundImage = styled.div`
  grid-row: 1 / 2;
  z-index: 1;
  grid-column: 1 / 2;
  height: 100%;
  max-height: 1150px;
  overflow: hidden;
  display: block;

  @media screen and (max-width: ${layout.sm}) {
    display: none;
  }
`

export const MobileBackgroundImage = styled.div`
  display: none;
  grid-row: 1 / 2;
  grid-column: 1 / 2;
  z-index: 1;
  min-height: 500px;

  img, .gatsby-image-wrapper {
    width: 100%;
    height: 100%;
  }

  @media screen and (max-width: ${layout.sm}) {
    display: block;
  }
`
